import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
// @material-ui/core components
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  TextField,
  IconButton,
  Icon,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
// @material-ui/styles
import styles from "../../../../../assets/jss/layouts/appStyle";
import { makeStyles } from "@material-ui/core/styles";
// core components
import { LOCALE } from "../../../../../properties/Locale";
import EntityMetadata from "../../../../../common/components/EntityMetadata";
import Card from "../../../../../common/components/Card/Card.js";
import CardHeader from "../../../../../common/components/Card/CardHeader.js";
import CardBody from "../../../../../common/components/Card/CardBody.js";
import { ProfessionalEventTypeRepository } from "./ProfessionalEventTypeRepository";

const useStyles = makeStyles(styles);

export default function ProfessionalEventTypeDetailsComponent(props) {
  const classes = useStyles();
  const [eventTypeId] = useState(props.match.params.eventTypeId);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  let { gradingSchemaId } = useParams();

  useEffect(() => {
    const loadEventType = (id) => {
      setLoading(true);
      ProfessionalEventTypeRepository.fetch(id).then((res) => {
        setData(res.data);
        setLoading(false);
      });
    };

    loadEventType(eventTypeId);
  }, [eventTypeId]);

  const handleClose = () => {};
  return (
    <div>
      <Card>
        <Dialog
          open={true}
          onClose={handleClose}
          maxWidth="md"
          fullWidth={true}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              overflowY: "unset",
            },
          }}
        >
          <CardHeader color="theme">
            <h4 className={classes.cardTitleWhite}>
              {`${LOCALE.event_details}`}
              <Link
                to={`/app/configuration/gradingSchema/${gradingSchemaId}/edit`}
                style={{ textDecoration: "none" }}
              >
                <IconButton
                  style={{ float: "right", color: "white" }}
                  aria-label="close"
                >
                  <Icon>close</Icon>
                </IconButton>
              </Link>
            </h4>
          </CardHeader>
          <CardBody>
            {loading ? <LinearProgress color="secondary" /> : ""}
            <div>
              <DialogContent>
                <TextField
                  id="name"
                  label={LOCALE.name}
                  size="small"
                  fullWidth={true}
                  margin="normal"
                  variant="outlined"
                  name="name"
                  value={data?.name ? data?.name : ""}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <FormControlLabel
                  size="small"
                  control={
                    <Checkbox
                      name={LOCALE.active}
                      color="primary"
                      checked={data?.active ? true : false}
                    />
                  }
                  label={LOCALE.active}
                />

                <EntityMetadata data={data} />
              </DialogContent>
              <DialogActions>
                <Link
                  to={`/app/configuration/gradingSchema/${gradingSchemaId}/edit`}
                  style={{ textDecoration: "none" }}
                >
                  <Button size="small" variant="outlined" color="secondary">
                    {LOCALE.cancel}
                  </Button>
                </Link>
              </DialogActions>
            </div>
          </CardBody>
        </Dialog>
      </Card>
    </div>
  );
}
